import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="border-t border-white/5 bg-paper" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-sm bg-gold/10 border border-gold/30 flex items-center justify-center">
                <span className="font-heading text-gold font-semibold text-lg">S</span>
              </div>
              <span className="font-heading text-xl text-[#EAEAEA] tracking-tight">
                Somalume
              </span>
            </Link>
            <p className="text-[#A1A1AA] text-sm leading-relaxed max-w-sm">
              Restoring coherence to the human system through pressure, breath, and field intelligence. 
              This is not metaphor — it is architecture.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading text-lg text-[#EAEAEA] mb-4">Explore</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/library" className="text-[#A1A1AA] text-sm hover:text-gold transition-colors duration-300">
                  Library
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-[#A1A1AA] text-sm hover:text-gold transition-colors duration-300">
                  About
                </Link>
              </li>
              <li>
                <Link to="/auth" className="text-[#A1A1AA] text-sm hover:text-gold transition-colors duration-300">
                  Sign In
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg text-[#EAEAEA] mb-4">Connect</h4>
            <ul className="space-y-2">
              <li>
                <a href="mailto:hello@somalume.org" className="text-[#A1A1AA] text-sm hover:text-gold transition-colors duration-300">
                  hello@somalume.org
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#A1A1AA] text-xs">
            © {new Date().getFullYear()} Somalume. All rights reserved.
          </p>
          <p className="text-[#A1A1AA] text-xs">
            Pressure creates presence.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
